import { render } from "./AssessmentQuiz.vue?vue&type=template&id=6e34fb6a"
import script from "./AssessmentQuiz.vue?vue&type=script&lang=js"
export * from "./AssessmentQuiz.vue?vue&type=script&lang=js"

import exportComponent from "/home/nils/assessment_tool/code/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__